module.exports = __webpack_public_path__ + "static/media/tv.36b51554.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tv.png
// module id = 2005
// module chunks = 0